<div class="meeting-card" [ngClass]="{ 'upcoming-card': type === 'upcoming' }" (click)="goto('Governance Meetings', meeting)">
  <div
    class="meeting-icon"
    [ngClass]="{ 'upcoming-icon': type === 'upcoming' }"
  >
    <div class="i-meeting" [ngClass]="{ 'i-upcoming': type === 'upcoming' }">
      <img *ngIf="type === 'upcoming'" src="/assets/images/bell_2.gif" />
      <img *ngIf="type === 'past'" src="/assets/images/calendar_1.gif" />
    </div>
  </div>
  <div class="message">
    <ng-container *ngIf="type === 'upcoming'">
      <label class="upcoming">Upcoming Meeting</label>
      <label class="date">{{
        meeting?.meetingDate | date : "dd/MM/yyyy"
      }}</label>
    </ng-container>
    <label *ngIf="type === 'past'" class="date" 
      >{{ meeting?.name }}
      {{ meeting?.meetingDate | date : "dd/MM/yyyy" }}</label
    >
  </div>
</div>
